import PropTypes from 'prop-types';
import React from 'react';
import PCMHeader from 'components/core/header/PCMHeader';
import TabbedNavigation from 'components/core/TabbedNavigation';
import Modals from 'components/core/modals/Modals';
import { Switch, Route } from 'react-router-dom';
import PCMHome from 'components/page/pcm-home/PCMHome';
import ProcessHome from 'components/page/process-home/ProcessHome';
import ProcessTutorials from 'components/page/process/ProcessTutorials';
import Process from 'components/page/process/Process';
import Search from 'components/page/search/Search';
import DependencyTree from 'components/page/process/DependencyTree';
import PageDoesNotExist from 'components/core/404';

const dodUrl = process.env.REACT_APP_DOD_URL; // injected by Node.js build environment parameters

class Redirect extends React.Component {
    componentWillMount(){
        window.location.replace(this.props.loc);
    }
    render(){
        return '';
    }
}

/**
 * The main template component for rendering pages
 */
export default class Main extends React.Component {
    static propTypes = {
        children: PropTypes.object,
        dispatch: PropTypes.func
    };

    isSpecialView(viewName) {
        let specialView = false;
        const segs = window.location.pathname.split('/');
        // because you could technically have a process named viewName, don't want this to break it
        if (segs.indexOf(viewName) > -1
            && (segs.indexOf('process') > segs.indexOf(viewName) || segs.indexOf('process') === -1)) {
            specialView = true;
        }
        return specialView;
    }

    render() {
        let dependencyView = this.isSpecialView('dependencies');
        let searchView = this.isSpecialView('search');
        let showTabs = dependencyView || searchView ? false : true;

        const renderHomePage = props => {
            // If there is a dodId in the query params, then we will redirect
            // to the dod page.
            let dodRequest = false;
            if (props.location.search.search('dodId=') >= 0) {
                dodRequest = true;
            }
            if(dodRequest) {
                const url = `${dodUrl}${props.location.search}`;
                return <Redirect loc={url}/>;
            } else {
                return <PCMHome/>;
            }
        }

        return (
            <div className="app-root">
                <Switch>
                    <Route exact path="/" render={renderHomePage}/>
                    <Route path="/*">
                        <div>
                            <PCMHeader dependencyView={dependencyView} searchView={searchView} />
                            <TabbedNavigation showTabs={showTabs} />
                            <main>
                                <Switch>
                                    <Route exact path="/processes" component={ProcessHome} />
                                    <Route exact path="/processes/tutorials" component={ProcessTutorials} />
                                    <Route exact path="/search" component={Search} />
                                    <Route path="/process/:processId/revision/:revisionNum" component={Process} />
                                    <Route path="/process/:processId" component={Process} />
                                    <Route path="/dependencies/:id" component={DependencyTree} />
                                    <Route exact path="*" component={PageDoesNotExist} />
                                </Switch>
                                {this.props.children}
                                <Modals />
                            </main>
                        </div>
                    </Route>
                </Switch>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/page/Main.js